module.exports = __webpack_public_path__ + "img/logo_musoon.2f9d79ca.svg";